import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Buttons from '../../core/Buttons';
import Icon from '../../core/Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import CommentsTextarea from '../../core/CommentsTextarea';

// Capa que envuelve todos los comentarios
export const StyleWrapTotalComments = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: 0 1rem 4.0625rem 1rem;
  ${mediaqueries.greaterThan('desktop')`
    border-top: ${rem('2px')} solid ${props => props.theme.colors.dark};
    padding: 2rem 0;
  `};
`;
// Capa que envuelve todos los comentarios para desktop
export const StyleWrapComments = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    max-width: 63.5rem;
    margin: 0 auto;
  `};
`;
// Capa que envuelve todos los comentarios para desktop colocarla a la izquierda con tamaño de la noticia
export const StyleWrapCommentsBox = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('648px')};
  `};
`;

// Titulo comentarios
export const StyledTitle = styled.span`
  color: ${props => props.theme.colors.light};
  display: inline-block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('15px')};
  padding: ${rem('5px')} ${rem('20px')} ${rem('5px')} ${rem('20px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('tablet')`
   font-size: ${rem('16px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
   font-size: ${rem('18px')};
  `};
`;
// Icono titulo comentarios
export const StyledIcon = styled(Icon)`
  margin: 0rem -1rem -0.22rem;
`;

// Texto Area
export const StyleTextArea = styled(CommentsTextarea)`
  margin: 0 0 ${rem('15px')} 0;
`;
// Formularo de Enviar comentario
export const StyleForm = styled.form`
  text-align: right;
`;
// Texto de Número de comentarios totales
export const StyleNumComments = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  padding-left: 0.6rem;
  ${mediaqueries.greaterThan('tablet')`
    padding-left: 0rem;
  `};
`;
// Botón de enviar
export const StyleButtonsSend = styled(Buttons)`
  border: ${rem('2px')} solid ${props => props.theme.colors.secondary};
  font-size: ${rem('12px')};
  height: auto;
  margin-bottom: ${rem('28px')};
  padding: ${rem('8px')} ${rem('15px')};
  ${props =>
    props.disabled &&
    css`
      border: none;
      background-color: ${props => props.theme.colors.secondary};
      opacity: 0.6;
      color: ${props => props.theme.colors.light};
      &:hover {
        background-color: ${props => props.theme.colors.secondary};
        color: ${props => props.theme.colors.light};
      }
    `};
  &:hover {
    border-color: ${props => props.theme.colors.dark};
  }
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    padding: ${rem('8px')} ${rem('20px')};
  `};
`;
// Wrap de Icono y Titulo comentarios
export const StyleWrapTitle = styled.h2`
  align-items: center;
  background-color: ${props => props.theme.colors.dark};
  display: inline-flex;
  margin-left: 1rem;
`;

// Ver las X respuestas
export const StyleButtonArrow = styled.a`
  color: ${props => props.theme.colors.dark};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('12px')};
  line-height: 0.6rem;
  margin: 0 0 1.8rem 1.8rem;
  &.hide {
    display: none;
  }
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    justify-content: center;
    line-height: 0.8rem;
    margin: 0 0 1.8rem 0;
  `};
`;
// Ver las X respuestas Icono
export const StyledIconArrowDown = styled(Icon)`
  fill: ${props => props.theme.colors.primary};
  height: 12px;
  margin: 0 0.75rem;
  transform: rotate(90deg);
  ${mediaqueries.greaterThan('tablet')`
    height: 14px;
  `};
`;
export const StyledIconArrowUp = StyledIconArrowDown.extend`
  transform: rotate(-90deg);
`;
